<template>
  <nav :style = '{"margin-top": `-${scrollTopValue}px`}' :class = '{nav_bg:scrollTopValue >= 80}' v-if = 'navList.length'>
    <div class = 'logo con'>
      <img src = '../assets/logo.png' alt = '' :style = '{"transform":`scale(${parseFloat((80 - scrollTopValue) / 80)})`, "top": `${scrollTopValue / 2}px`}'/>
    </div>
    <div :class = 'scrollTopValue >= 80 ? "nav_con nav_con_b con flex_between" : "nav_con con flex_between"'>
      <div class = 'nav_social flex_between'>
        <a class = 'nav_social_item' v-for = '(item,index) in navSocial' :href = "index ? item.src : 'javascript:void(0);'" :target = 'index ? "_blank" : ""' >
          <div class = 'social_img' v-if = '!index'>
            <img :src = 'item.pic' alt = ''/>
          </div>
        </a>
      </div>
      <ul class = 'nav_list flex_between'>
        <li v-for = '(item, index) in navList' :class = '(!index || index == navList.length - 1) ? "nav_item nav_item_bg" : "nav_item"'>
          <router-link :to = '{path: item.path}'><span class = 'opensans-semibold nav_title' :class = '{active: activeIndex == index}'>{{item["name_" + lang]}}</span></router-link>
          <div class = 'nav_items' v-if = '!index'>
            <div class = 'nav_items_img'>
              <div>
                <img :src = 'imgSrc ? imgSrc : "//cdn.idsbuybuybuy.com/image_20190823192015_31635.png"' alt = ''/>
              </div>
            </div>
            <div class = 'nav_items_con flex_between'>
              <div class = 'nav_items_child' v-for = '(child,childIndex) in item.child'>
                <div :class = 'childIndex > 2 ? "nav_items_child_title mt" : "nav_items_child_title"' @click = 'seriesChange(child.address)' @mouseenter.stop = 'mouseEnter(child.src)'>
                  <i :class = '{activeTitle: curPath == child.address}' class = 'opensans-semibold'>{{child["title_" + lang]}}</i>
                  <router-link  v-if = 'false' :class = 'curPath == child.address ? "active" : ""' :to = '{path: "/series/" + child.address}'>{{child["title_" + lang]}}</router-link>
                </div>
                <div class = 'nav_items_child_product' v-for = '(childs,childsIndex) in child.child' @mouseenter.stop = 'mouseEnter(childs.src)'>
                  <router-link class = 'opensans-regular' :class = 'curPath == childs.address ? "active" : ""' target = '_blank' :to = "{path: '/goodsDetail/' + childs.address}">{{childs["title_" + lang]}}</router-link>
                </div>
              </div>
            </div>
          </div>
          <div class = 'about_s flex_between' v-if = 'index == navList.length - 1'>
            <div v-for = 'child in item.child' :class = '"/" + curPath == child.path ? "active" : ""'>
              <router-link :to = '{"path":child.path}'>{{child["title_" + lang]}}</router-link>
            </div>
          </div>
        </li>
      </ul>
      <div class = 'nav_lang'>
        <span :class = 'lang != "EN" ? "active" : ""'  @click = 'changeLang'>中</span>
        <span>/</span>
        <span :class = 'lang == "EN" ? "active" : ""' @click = 'changeLang'>EN</span>
      </div>
    </div>
  </nav>
</template>
<script>
//         // "src": "//cdn.idsbuybuybuy.com/image_20191011164224_46416.jpeg",
  import $ from 'jquery';
  export default {
    props: {
      activeIndex: {
        type: String,
        default: ''
      },
      secondAddress: {//二级导航高亮显示的地址
        type: String,
        default: ''
      }
    },
    data () {
      return {
        navSocial: [
          {pic: '//cdn.idsbuybuybuy.com/image_20191007175932_55528.jpeg'},
          {src: 'https://weibo.com/p/1006067228690362/home'},
          {src: 'https://instagram.com/yusumtongofficial?igshid=17bzi8mhcp3ri'},
          {src: 'https://www.facebook.com/YU-SUM-TONG-674038333018382/'},
          ],
        scrollTopValue: 0,
        navList: [],//导航信息
        imgSrc: '',//产品图片
        timer: null,
        curPath: ''
      }
    },
    computed: {
      lang () {
        return this.$store.getters.getStoreLang;
      },
    },
    created () {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      this.scrollTopValue = scrollTop > 80 ? 80 :  scrollTop;
      this.getNavList();
      let arr = this.$route.path.split('/');
      this.curPath = arr[arr.length - 1];
    },
    updated(){
      let arr = this.$route.path.split('/'),curPath = arr[arr.length - 1];
      curPath == this.curPath ? null : this.curPath = arr[arr.length - 1];
    },
    mounted() {
      // 防抖节流  多次触发
      let flag = true;
      window.addEventListener('scroll',(e) => {
        let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        scrollTop > 80 ? (this.scrollTopValue == 80 ? null : this.scrollTopValue = 80) : this.scrollTopValue = scrollTop;
        flag = true;
      })
    },
    methods: {
      getNavList(){
        if(!this.navList.length){
          const url = "../../static/json/nav/nav.json";
          this.$.get(url).then((res) => {
            this.navList = res.data;
            this.imgSrc = this.navList[0].child[0].src;
          })
        }
      },
      // 切换系列
      seriesChange(address){
        this.curPath = address;
        this.$router.push({
          path: '/series/' + address
        })
        // setTimeout(() => this.$router.go(0))//刷新页面
      },
      // 切换语言
      changeLang(){
        let type = this.lang == 'EN' ? 'CN': 'EN'
        this.$store.dispatch('setStoreLang', type);
        window.localStorage.setItem('lang', type);
      },
      //  导航(移入/出)产品(显示/隐藏)产品图片
      mouseEnter(src){
        this.imgSrc = src
      },
      mouseOut(index){
        if(!index) this.imgSrc = this.navList[0].child[0].src;
      }
    }
  }
</script>
<style lang="scss" scoped> 
  nav{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 9999;
    padding-top: 30px;
    color: #fff;
    font-family: 'open-sans';
    &.nav_bg{
      background-color: rgba(0,0,0,0.95);
    }
    .con{
      margin: 0 auto;
    }
    .logo img{
      margin: 0 auto;
      width: 76px;
      height: auto;
      position: relative;
    }
    .nav_con{
      margin-top: 22px;
      width: 1076px;
      border-top: 1px solid rgba(255,255,255,.4);
      height: 40px;
      // padding-bottom: 17px;
      transition: all 0.5s;
      &.nav_con_b{
        width: 90%;
      }
      .nav_social{
        width: 160px;
        align-items: center;
        .nav_social_item{
          position: relative;
          width: 40px;
          height: 40px;
          background-image: url('//cdn.idsbuybuybuy.com/image_20191008181152_53470.png');
          background-repeat: no-repeat;
          background-position: center;
          background-size: cover;
          cursor: pointer;
          &:nth-of-type(1):hover{
            background-image: url("//cdn.idsbuybuybuy.com/image_20191008181152_80665.png");
          }
          &:nth-of-type(2){
            background-image: url('//cdn.idsbuybuybuy.com/image_20191008181153_61001.png');
            &:hover{
              background-image: url("//cdn.idsbuybuybuy.com/image_20191008181153_21875.png");
            }
          }
          &:nth-of-type(3){
            background-image: url('//cdn.idsbuybuybuy.com/image_20191008181152_69577.png');
            &:hover{
              background-image: url("//cdn.idsbuybuybuy.com/image_20191008181152_40014.png");
            }
          }
          &:nth-of-type(4){
            background-image: url('//cdn.idsbuybuybuy.com/image_20191008181152_90538.png');
            &:hover{
              background-image: url("//cdn.idsbuybuybuy.com/image_20191008181152_77390.png");
            }
          }
          .social_img{
            display:none;
            position: absolute;
            top: 40px;
            left: 50%;
            transform: translateX(-50%);
            width: 120px;
            height: 120px;
            background-color: #ffffff;
            border-radius: 10px;
            img{
              width: 100px;
              height: 100px;
              object-fit: cover;
              margin: 10px auto;
            }
          }
          &:hover{
            .social_img{
              display: block;
            }
          }
        }
      }
      .nav_list{
        width: 594px;
        margin-left: -7.5%;
        .nav_item{
          position: relative;
          width: 100px;
          text-align: center;
          .nav_items{
            max-height: 800px;
            position: fixed;
            left: 50%;
            transform: translateX(-50%);
            width: 100%;
            background: rgba(0,0,0,.88);
            padding: 4.2% 8%;
            box-sizing: border-box;
            display: none;
            text-align: left;
            .nav_items_img{
              position: relative;
              width: 20%;
              min-height: 212px;
              div{
                position: absolute;
                top: 0;
                left: 0;
                padding-bottom: 20%;
                img{
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                }
              }
            }
            .nav_items_con{
              margin-left: 5%;
              flex-wrap: wrap;
              flex: 1;
              .nav_items_child{
                width: 30%;
                div:hover,.active{
                  color: #fff;
                }
                .nav_items_child_title{
                  font-size: 14px;
                  line-height: 19px;
                  color: #999;
                  padding-bottom: 20px;
                  cursor: pointer;
                  &.mt{
                    margin-top: 40px;
                  }
                  i.activeTitle{
                    color: #fff;
                  }
                }
                .nav_items_child_product{
                  font-size: 12px;
                  color: #666;
                  line-height: 15px;
                  margin-bottom: 3px;
                  cursor: pointer;
                  .nav_items_product_img{
                    position: absolute;
                  }
                }
              }
              a.active{
                color: #fff;
              }
            }
          }
          span{
            position: relative;
            display: inline-block;
            line-height: 40px;
            height: 40px;
            color: rgba(255,255,255,.6);
            font-size: 14px;
            &:before{
              content:'';
              height: 2px;
              background: #fff;
              position: absolute;
              top: -2px;
              width: 0;
              left: 50%;
              transition: all 0.3s;
            }
            &:hover{
              cursor: pointer;
              color: #fff;
              &:before{
                width: 100%;
                left: 0;
              }
            }
            &.active:before{
              width: 100%;
              left: 0;
            }
            &.active{
              color: #fff;
            }
          }
          &.nav_item_bg{
            span{
              &:after{
                content: url('//cdn.idsbuybuybuy.com/image_20190826184944_44469.png');
                margin-left: 8px;
              }
            }
          }
          &:hover{
            .nav_items,.about_s{
              display: flex;
            }
          }
        }
        .about_s{
          display: none;
          width: 195px;
          position: absolute;
          left: -50px;
          background: rgba(0,0,0,.95);
          padding: 40px;
          box-sizing: border-box;
          color: #999;
          font-size: 14px;
          // height: 167px;
          height: 130px;
          flex-direction: column;
          cursor: pointer;
          div{
            &.active,&:hover{
              color: #fff;
            }
          }
        }
      }
      .nav_lang{
        width: 68px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        color: #999;
        span{
          cursor: pointer;
          &.active{
            color: #fff;
          }
        }
      }
    }
  }
  @media screen and (min-width: 1920px) {
    nav .nav_con .nav_list .nav_item .nav_items{
      height: 800px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/common/nav.vue